export default "__VITE_ASSET__a9069bdf__"